import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { ProductDetail } from 'src/@omnial/_models/catalog/product.model';
import { ProductReviewSubmitDialogComponent } from '../product-review-submit-dialog/product-review-submit-dialog.component';
import { AppSettings } from 'src/app/app.settings';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-product-review',
    templateUrl: './../../../app/shared/product-review/product-review.component.html',
    styleUrls: ['./../../../app/shared/product-review/product-review.component.scss'],
    standalone: false
})

export class ProductReviewComponent {
  @Input() public product: ProductDetail;
  @Input() public dialogButton = true;
  public subscriptions: Subscription[] = [];

  constructor(public settings: AppSettings, public dialog: MatDialog) { }

  public init(product: ProductDetail) {
    this.product = product;
  }

  public openSubmitDialog(): void {
    this.dialog.open(ProductReviewSubmitDialogComponent, {
      data: this.product,
      autoFocus: false,
      maxHeight: '90vh',
      maxWidth: '1000px'
    });
  }
}
